// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2BIRc","header":"ReportDetails_header__2QG-c","title":"ReportDetails_title__1qCmv","left":"ReportDetails_left__10DeP"};